import { AHText, Box, TouchableBox, useLayoutContext, useTheme } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { ProductExpireBatchListItemContent_StoreProductExpireBatch$key } from "./__generated__/ProductExpireBatchListItemContent_StoreProductExpireBatch.graphql";
import { Image } from "expo-image";
import { DateTime } from "luxon";
import { ProductExpireBatchListItemAction } from "./ProductExpireBatchListItemAction";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { ProductExpireBatchListItem_StoreProductExpireBatch$key } from "./__generated__/ProductExpireBatchListItem_StoreProductExpireBatch.graphql";

export function ProductExpireBatchListItemContent(props: {
  productExpireBatch: ProductExpireBatchListItemContent_StoreProductExpireBatch$key;
}) {
  const layout = useLayoutContext();
  const theme = useTheme();
  const intl_tokens = useIntlTokens();
  const productExpireBatch = useFragment(
    graphql`
      fragment ProductExpireBatchListItemContent_StoreProductExpireBatch on StoreProductExpireBatch {
        id
        expireAtDate {
          isoString
        }
        product {
          id
          name
          imageUrl
        }
      }
    `,
    props.productExpireBatch
  );
  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <Box style={{ flex: 1, flexDirection: "column" }}>
        <AHText type="subtitle" color="text-secondary">
          {intl_tokens.ExpireDate}{" "}
          {DateTime.fromISO(productExpireBatch.expireAtDate.isoString).toFormat(
            "dd-MM-yyyy"
          )}
        </AHText>
        <AHText
          spaceTop="xsmall"
          type="subtitle"
          color="text-secondary"
          numberOfLines={1}
        >
          {productExpireBatch.product?.name}
        </AHText>
      </Box>
      {productExpireBatch.product?.imageUrl ? (
        <Image
          source={{
            uri: productExpireBatch.product.imageUrl,
          }}
          style={{
            width: layout.circle.large,
            height: layout.circle.large,
            borderColor: theme["border-primary"],
            borderWidth: 1,
            borderRadius: layout.radius.small,
            marginLeft: layout.space.medium,
          }}
        />
      ) : null}
    </Box>
  );
}

function ProductExpireBatchListItemC(props: {
  productExpireBatch: ProductExpireBatchListItem_StoreProductExpireBatch$key;
  onPress: (id: string) => void;
}) {
  const productExpireBatch = useFragment(
    graphql`
      fragment ProductExpireBatchListItem_StoreProductExpireBatch on StoreProductExpireBatch {
        id
        activeAction {
          id
          ...ProductExpireBatchListItemAction_StoreProductExpireBatchAction
        }
        ...ProductExpireBatchListItemContent_StoreProductExpireBatch
      }
    `,
    props.productExpireBatch
  );

  return (
    <TouchableBox
      color="surface-primary"
      spaceHorizontal="medium"
      spaceVertical="medium"
      onPress={() => props.onPress(productExpireBatch.id)}
    >
      <ProductExpireBatchListItemContent
        productExpireBatch={productExpireBatch}
      />

      {productExpireBatch.activeAction ? (
        <ProductExpireBatchListItemAction
          productExpireBatchAction={productExpireBatch.activeAction}
        />
      ) : null}
    </TouchableBox>
  );
}

export const ProductExpireBatchListItem = React.memo(
  ProductExpireBatchListItemC
);
